export default {
  de: {
    back: 'Zurück',
    delete: 'Löschen',
    print: 'Drucken',
  },
};
